import { CustomerDocumentArchiveResponse } from '@lio/api-types';
import { config } from '@services/config';
import { useQuery } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

export const useGetCustomerDocumentArchive = (customerId: string | undefined, enabled = true) => {
  const client = useClient();
  const result = useQuery<CustomerDocumentArchiveResponse, Error>({
    queryKey: ['customer', customerId, 'document-archive'],
    queryFn: () => client.get(`customer/${customerId}/document-archive`).json<CustomerDocumentArchiveResponse>(),
    enabled: !!customerId && enabled,
    refetchOnWindowFocus: false,
    ...config,
  });
  return { ...result, archive: result.data };
};
